// Mock data for NutExpert clone - All Nuts Shop

export const SITE = {
  brand: "NutExpert",
  tagline: "The finest nuts, sourced with care",
  description:
    "In a relationship of trust and open-mindedness with our growers, NUT EXPERT curates and delivers the world's finest nuts \u2014 from sun-ripened almonds to mountain-grown walnuts \u2014 contributing to a healthier and more sustainable way of snacking.",
};

export const NAV = [

  {
    label: "OUR NUTS",
    href: "#products",
    children: [
      { label: "Almonds", href: "/product/almonds" },
      { label: "Walnuts", href: "/product/walnuts" },
      { label: "Cashews", href: "/product/cashews" },
      { label: "Pistachios", href: "/product/pistachios" },
      { label: "Hazelnuts", href: "/product/hazelnuts" },
      { label: "Mixed nuts", href: "/product/mixed-nuts" },
    ],
  },
  {
    label: "NUTRITION",
    href: "#benefits",
    children: [
      { label: "Know nuts better", href: "#benefits" },
      { label: "Nuts in figures", href: "#stats" },
    ],
  },
  { label: "CONTACT US", href: "#contact" },
];

export const HERO_BANNERS = [
  {
    id: 1,
    eyebrow: "In all their forms",
    title: "The Nuts",
    description:
      "Whether raw, roasted, salted or transformed into creamy butters, nuts deliver outstanding benefits \u2014 plant\u2011based proteins, good fats and essential minerals.",
    cta: "Discover our nuts",
    href: "#products",
    image:
      "https://images.unsplash.com/photo-1600189020840-e9918c25269d?w=2400&q=80",
  },
  {
    id: 2,
    eyebrow: "Premium harvest 2025",
    title: "Wholesome by nature",
    description:
      "From orchard to jar \u2014 every batch is selected by hand, roasted slowly and packed at peak freshness.",
    cta: "Explore the collection",
    href: "#products",
    image:
      "https://images.unsplash.com/photo-1616252576862-bd9abd7467f9?w=2400&q=80",
  },
  {
    id: 3,
    eyebrow: "Organic & traceable",
    title: "Just good nuts",
    description:
      "Sustainable partnerships with growers across five continents, ensuring traceability from the field to your shelf.",
    cta: "Our commitment",
    href: "#csr",
    image:
      "https://images.unsplash.com/photo-1600189083288-89e1c8b9b0cc?w=2400&q=80",
  },
];

export const BRAND_TILES = [
  {
    id: "bionut",
    label: "Bionut, just organic",
    image:
      "https://images.unsplash.com/photo-1600189083288-89e1c8b9b0cc?w=900&q=80",
    href: "/product/almonds",
  },
  {
    id: "kahuet",
    label: "Roastery, slow roasted",
    image:
      "https://images.unsplash.com/photo-1615110250484-e8c3b151b957?w=900&q=80",
    href: "/product/cashews",
  },
  {
    id: "dcr",
    label: "Mountain, walnut harvest",
    image:
      "https://images.unsplash.com/photo-1524593656068-fbac72624bb0?w=900&q=80",
    href: "/product/walnuts",
  },
  {
    id: "kahuet2",
    label: "Verde, premium pistachios",
    image:
      "https://images.unsplash.com/photo-1704079662049-d00890d21a69?w=900&q=80",
    href: "/product/pistachios",
  },
];

export const PRODUCTS = [
  {
    id: "almonds",
    slug: "almonds",
    name: "California Almonds",
    short: "Whole Almonds",
    blurb:
      "Sweet, crisp almonds harvested in sun\u2011drenched orchards. Perfect for snacking, baking or pressing into smooth almond butter.",
    price: 12.9,
    weight: "500 g",
    origin: "California, USA",
    image:
      "https://images.unsplash.com/photo-1615485737457-f07082c77813?w=1200&q=80",
    badges: ["Raw", "Unsalted"],
  },
  {
    id: "walnuts",
    slug: "walnuts",
    name: "Mountain Walnuts",
    short: "Shelled Halves",
    blurb:
      "Cold\u2011climate walnut halves rich in omega\u20113. Buttery, slightly bitter and full of character.",
    price: 14.5,
    weight: "400 g",
    origin: "Gren\u00f6ble, France",
    image:
      "https://images.unsplash.com/photo-1524593656068-fbac72624bb0?w=1200&q=80",
    badges: ["Raw", "Omega\u20113"],
  },
  {
    id: "cashews",
    slug: "cashews",
    name: "Roasted Cashews",
    short: "Lightly Salted",
    blurb:
      "Creamy, crescent\u2011shaped cashews slowly roasted and finished with a touch of sea salt.",
    price: 16.0,
    weight: "500 g",
    origin: "Vietnam",
    image:
      "https://images.unsplash.com/photo-1615485925873-7ecbbe90a866?w=1200&q=80",
    badges: ["Roasted", "Sea salt"],
  },
  {
    id: "pistachios",
    slug: "pistachios",
    name: "Sicilian Pistachios",
    short: "In Shell",
    blurb:
      "Vivid green pistachios from Bronte, slow roasted in shell for a bold, sweet crunch.",
    price: 19.9,
    weight: "350 g",
    origin: "Bronte, Italy",
    image:
      "https://images.unsplash.com/photo-1704079662049-d00890d21a69?w=1200&q=80",
    badges: ["Roasted", "Premium"],
  },
  {
    id: "peanuts",
    slug: "peanuts",
    name: "Honey Roasted Peanuts",
    short: "With shells",
    blurb:
      "Classic peanuts with a thin golden honey glaze \u2014 the perfect movie\u2011night companion.",
    price: 7.5,
    weight: "500 g",
    origin: "Argentina",
    image:
      "https://images.unsplash.com/photo-1549978113-29eb25c8177f?w=1200&q=80",
    badges: ["Roasted", "Honey"],
  },
  {
    id: "hazelnuts",
    slug: "hazelnuts",
    name: "Piedmont Hazelnuts",
    short: "Whole Kernels",
    blurb:
      "Fragrant Tonda Gentile hazelnuts \u2014 the same variety used by the world's best chocolatiers.",
    price: 17.5,
    weight: "400 g",
    origin: "Piedmont, Italy",
    image:
      "https://images.unsplash.com/photo-1635843130314-c0b5cc832b79?w=1200&q=80",
    badges: ["Raw", "DOP"],
  },
  {
    id: "macadamia",
    slug: "macadamia",
    name: "Macadamia Nuts",
    short: "Roasted",
    blurb:
      "Rich, buttery macadamias from Australia. Indulgent on their own or with dark chocolate.",
    price: 22.0,
    weight: "300 g",
    origin: "Queensland, Australia",
    image:
      "https://images.unsplash.com/photo-1615485925822-77040a19d84b?w=1200&q=80",
    badges: ["Roasted", "Luxury"],
  },
  {
    id: "mixed-nuts",
    slug: "mixed-nuts",
    name: "House Mixed Nuts",
    short: "Our Signature Blend",
    blurb:
      "A balanced blend of cashews, almonds, walnuts and hazelnuts \u2014 perfectly portioned for sharing.",
    price: 15.9,
    weight: "500 g",
    origin: "Multi\u2011origin",
    image:
      "https://images.pexels.com/photos/11931801/pexels-photo-11931801.jpeg?w=1200&q=80",
    badges: ["Mixed", "Best seller"],
  },
];

export const BENEFITS = [
  {
    n: 1,
    color: "#f0a431",
    title: "High in protein",
    text: "Tree nuts and peanuts are some of nature's most protein\u2011dense plant foods, supporting muscle development and recovery.",
  },
  {
    n: 2,
    color: "#3a3a3a",
    title: "Nutritional value",
    text: "Nuts deliver fiber, minerals and antioxidants \u2014 a small handful goes a long way for everyday wellbeing.",
  },
  {
    n: 3,
    color: "#cb2027",
    title: "\u201cGood\u201d fatty acids",
    text: "Most nuts are rich in mono\u2011unsaturated fats (the kind found in olive oil) that help lower bad cholesterol.",
  },
  {
    n: 4,
    color: "#f0a431",
    title: "Full of vitamins",
    text: "Vitamin E, magnesium, potassium, B vitamins, zinc, selenium and iron \u2014 nuts are a multivitamin from nature.",
  },
  {
    n: 5,
    color: "#1fb8a8",
    title: "Satiating effect",
    text: "A 30 g handful of nuts is enough to satisfy hunger \u2014 making them the ideal mid\u2011day snack.",
  },
  {
    n: 6,
    color: "#3a3a3a",
    title: "Antioxidant effect",
    text: "Polyphenols found in nuts help fight cellular aging and protect against chronic disease.",
  },
];

export const STATS = [
  {
    value: "25",
    suffix: " g",
    label: "of plant protein in a 100 g serving of nuts on average \u2014 ideal for vegans and athletes",
  },
  {
    value: "80",
    suffix: "%",
    label: "of European nut imports come from California, Turkey, Iran, Vietnam and Argentina",
  },
  {
    value: "600",
    suffix: " kcal",
    label: "per 100 g of nuts on average \u2014 about 28% of an adult daily intake",
  },
];

export const FOOTER = {
  columns: [
    
    {
      title: "Our nuts",
      items: [
        "Almonds",
        "Walnuts",
        "Cashews",
        "Pistachios",
        "Hazelnuts",
        "Mixed nuts",
      ],
    },
   
  ],
  contact: {
    address: "6, rue de la Garenne 10350 Marigny-le-Châtel.",
    email: "Operation@nutexpert.fr   Office@nutexpert.fr",
  },
};
